import { Icon } from '@toggle/design-system';
import React from 'react';

import styles from './DocumentProvider.module.scss';
import { isValidIcon } from './utils';

export type DocumentProviderProps = {
  documentKind: string;
  date?: string;
  iconSize?: number;
  customText?: string;
};

export const DocumentProvider = ({
  documentKind,
  date,
  iconSize = 12,
  customText,
}: DocumentProviderProps) => {
  const formattedProvider = documentKind
    ? `${documentKind[0].toUpperCase()}${documentKind.slice(1)}`
    : '';
  const labelText = customText ?? `${formattedProvider} | ${date}`;
  return (
    <div className={styles.root} data-testid="provider-cell">
      {isValidIcon(formattedProvider) && (
        <Icon iconName={formattedProvider} size={iconSize} />
      )}
      <span
        className={styles.styledLabel}
        data-provider-string
        data-testid="provider-string"
      >
        {labelText}
      </span>
    </div>
  );
};
